import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {map, switchMap} from 'rxjs';
import * as fromActions from "./instution-user.actions";
import * as fromGraphql from "./instution-user.graphql"


@Injectable()
export class InstutionUserEffects {

  createInstitutionUsers = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createInstitutionUsers),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_INSTUTION_USERS,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertInstutionUser({ instutionUser: result?.data }));
              this.notificationService.successMessage('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateInstitutionUsers$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateInstitutionUsers),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_INSTUTION_USERS,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertInstutionUser({ instutionUser: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  removeInstitutionUsers$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeInstitutionUsers),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_INSTUTION_USERS,
        variables: {
          profileUniqueId: action?.profileUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteInstutionUser({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  activateDeactivateUsers$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.activateDeactivateUser),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.ACTIVATE_DEACTIVATE_USER_MUTATION,
        variables: {
          profileUniqueId: action?.profileUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred'),
        map(({data}: any) => {
          if(data){
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertInstutionUser({ instutionUser: result?.data }));
              this.notificationService.successMessage("Operation Successful")
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      )
    })
  ), {dispatch : false})

  getInstitutionUsers$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getInstitutionUsers),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_INSTUTIONAL_USERS,
        fetchPolicy: 'network-only',
        variables:{
          filtering:action?.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadInstutionUsers({ instutionUsers: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
